import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[year]/page.js");
